'use client';

import {useMediaQuery} from '@mui/material';

export function Desktop(props: any): JSX.Element | null {
  const matches = useMediaQuery('(min-width:1025px)');

  if (matches) return props.children;
  return null;
}
